import { render, staticRenderFns } from "./mo-address-form.html?vue&type=template&id=c69c5132&external"
import script from "./mo-address-form.ts?vue&type=script&lang=ts&external"
export * from "./mo-address-form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/2/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c69c5132')) {
      api.createRecord('c69c5132', component.options)
    } else {
      api.reload('c69c5132', component.options)
    }
    module.hot.accept("./mo-address-form.html?vue&type=template&id=c69c5132&external", function () {
      api.rerender('c69c5132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-address-form/mo-address-form.vue"
export default component.exports